import { ReportedElementI } from "@/interfaces/galleries/Galleries";
import "./ReportForm.scss";
import { object, string } from "yup";
import { useFormik } from "formik";
import { useState } from "react";
import CustomSpinner from "../CustomSpinner/CustomSpinner";
import { reportElement } from "@/services/PhotosService";
import { usePhotoViewContext } from "@/context/PhotoViewContext";
import { useUserContext } from "@/context/UserContext";
import { notifySuccess } from "@/utils/NotificationFunctions";
import { SelectButton } from "../Elements/SelectButton";
import { ReportedSchema } from "@/interfaces/reported/reported-schema";

interface ReportFormComponentPropsI {
  type: string;
  reportedElement?: ReportedElementI | null;
  onHide: () => void;
}

const reportSchema = object({
  reason: string().required("A reason is required"),
});

const reportSchema2 = object({
  reason: string().required("A reason is required"),
  name: string().required("A name is required"),
});
const coolText =
  "What is so Cool about it?\nTo match,  it must be interesting, or fun, or extreme.\nOr is it Rare ?";
function ReportForm(props: ReportFormComponentPropsI) {
  const { type, reportedElement, onHide } = props;
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const [isCoolRare, setIsCoolRare] = useState<boolean>(false);
  const { photo } = usePhotoViewContext();
  const { userToken } = useUserContext();

  const handleCoolRare = () => {
    formik.setFieldValue("reason", "");
    setIsCoolRare(!isCoolRare);
  };
  const formik = useFormik({
    initialValues: {
      reason: "",
      ...(!userToken && { name: "" }),
    },
    validationSchema: !!userToken ? reportSchema : reportSchema2,
    onSubmit: async (values, { resetForm }) => {
      if (reportedElement && photo) {
        setLoadingSubmit(true);
        const data: ReportedSchema = {
          galleryId: reportedElement.galleryId,
          type: type,
          url: photo.url,
          report: values.reason,
          ...(!userToken && { name: values.name }),
          ...(type === "photo" && { photoId: reportedElement.id, isCoolRare }),
          ...(type === "comment" && { commentId: reportedElement.id }),
          ...(type === "discussion" && { discussionId: reportedElement.id }),
        };
        reportElement(data, userToken).then((res) => {
          setLoadingSubmit(false);
          notifySuccess(type + " reported successfully!");
          onHide();
          resetForm();
        });
      }
    },
  });

  const { errors, touched } = formik;

  return (
    <form onSubmit={formik.handleSubmit} className="report-name-form-component">
      {!userToken && (
        <div className="c-row">
          <label htmlFor="name">Name</label>
          <input
            autoComplete="off"
            name="name"
            id="name"
            value={formik.values.name}
            placeholder="Name"
            onChange={formik.handleChange}
          />
          {errors.reason && touched.reason && (
            <div className="form-error">{errors.reason}</div>
          )}
        </div>
      )}
      <div
        className="flex items-center gap-3 cursor-pointer"
        onClick={handleCoolRare}
      >
        <SelectButton selected={isCoolRare} />
        <p>
          Report this photo as Cool / Rare so other people can filter it (+50
          points)
        </p>
      </div>
      <div className="c-row">
        <label htmlFor="reason">Reason</label>
        <textarea
          name="reason"
          id="reason"
          value={formik.values.reason}
          placeholder={
            isCoolRare ? coolText : "Why are you reporting this content"
          }
          onChange={formik.handleChange}
          rows={6}
        />
        {errors.reason && touched.reason && (
          <div className="form-error">{errors.reason}</div>
        )}
      </div>
      <button
        type="submit"
        className="btn linear-bg w-100"
        disabled={loadingSubmit}
      >
        {loadingSubmit ? <CustomSpinner size={2} borderWidth={1} /> : "Save"}
      </button>
    </form>
  );
}

export default ReportForm;
